<template>
  <div class="authServer">
    <!-- <SearchForm :searchConfig="searchConfig" @callBackAction="callBackAction" /> -->
    <Table
      ref="child"
      :tableConfig="tableConfig"
      :tableData="tableData"
      @callBackAction="callBackAction"
      :api="api"
      :type="type"
      :tableHeight="tableHeight"
    />
    <Drawer
      v-if="showDrawer"
      :showDrawer="showDrawer"
      @changeDrawer="changeDrawer"
      :drawerMode="drawerMode"
      :formData="formData"
      @addoredit="addoredit"
      :type="type"
      :addoreditForm="addoreditForm"
      :drawerTitle="drawerTitle"
      :selectedItems="selectedItems"
    />
    <Dialog
      :dialogFormVisible="dialogFormVisible"
      @setDialog="setDialog"
      :dialogType="dialogType"
      :dialogTitle="dialogTitle"
      :eventType="eventType"
    />
  </div>
</template>

<script>
// import SearchForm from "@/components/searchForm/index.vue";
import Table from "./table.vue";
import Drawer from "./addEditDrawer.vue";
import Dialog from "@/components/dialog/index.vue";
import {
  getResourceTree,
  addResource,
  updateResource,
  deleteResource,
} from "@/api/authorization.js";

export default {
  components: { Table, Drawer, Dialog },
  data() {
    return {
      tableHeight: document.documentElement.clientHeight - 250,
      formInline: {},
      selectedItems: [],
      eventType: "",
      dialogTitle: this.$t(`common.alert`),
      dialogType: "yellowType",
      dialogFormVisible: false,
      drawerTitle: "",
      addoreditForm: {},
      formData: [],
      showDrawer: false,
      type: "resource",
      drawerMode: "add", //edit
      api: {},
      father:{},
      tableData: {},
      searchConfig: {},
      tableConfig: {
        form: {
          params: [
            {
              type: "input",
              model: "inputKey",
              placeholder: `common.inputKey`,
            },
          ],
          actions: [
            {
              type: "query",
              name: "common.query",
              event: "query",
              auth: "resource_query",
            },
            {
              type: "add",
              name: "common.add",
              event: "add",
              auth: "resource_add",
            },
            {
              type: "edit",
              name: "common.edit",
              event: "edit",
              auth: "resource_edit",
            },
            {
              type: "remove",
              name: "common.remove",
              event: "remove",
              auth: "resource_delete",
            },
            {
              type: "resourceImport",
              name: "common.uploadResource",
              event: "resourceImport",
              auth: "resource_import",
            },
            {
              type: "resourceExport",
              name: "common.resourceExport",
              event: "resourceExport",
              auth: "resource_export",
            },
            // { type: "connect", name: "关联资源分组", event: "connect" },
            // { type: "export", name: "导出人员", event: "export" },
          ],
        },
        currentForm: {}, //当前待编辑确定的表格
        table: {
          selection: true,
          columns: [
            {
              prop: "resCode",
              label: `authorization.resource.resCode`,
              width: "150",
              required: true,
              placeholder: `authorization.resource.onlyCodeRule`,
            },
            {
              prop: "resName",
              label: `authorization.resource.resName`,
              width: "150",
              required: true,
            },
            {
              prop: "resNameCn",
              label: `authorization.resource.resNameCn`,
              minWidth: "150px",
              required: false,
            },
            {
              prop: "belongSys",
              label: `authorization.resource.belongSys`,
              width: "",
              required: true,
            },
            {
              prop: "resType",
              label: `authorization.resource.resType`,
              width: "",
              required: true,
            },
            {
              prop: "status",
              label: `authorization.resource.status`,
              width: "",
              required: false,
            },
            {
              prop: "resIcon",
              label: `authorization.resource.icon`,
              width: "",
              required: false,
            },
            {
              prop: "resSequence",
              label: `authorization.resource.resSequence`,
              width: "",
              required: true,
            },
            // { prop: "resParent", label: "父级资源", width: "620" ,required:true},
            {
              prop: "remark",
              label: `common.remark`,
              width: "",
              required: false,
            },
            {
              prop: "resContent",
              label: `authorization.resource.resContent`,
              width: "",
              required: false,
            },
            // { prop: "resIcon", label: "使用图标", width: "620",required:false },
            // { prop: "resIconType", label: "图标类型", width: "620",required:false },
            {
              prop: "moduleText",
              label: `authorization.resource.moduleText`,
              width: "",
              required: false,
            },
            // { prop: "moduleImg", label: "模块详情图片", width: "620",required:false },
            {
              prop: "urlList",
              label: `authorization.resource.urlList`,
              width: "",
              required: false,
            },
          ],
          action: {},
        },
      },
    };
  },
  computed: {
    buttonAuth: function () {
      return this.$store.getters.auth.buttonAuth;
    },
  },
  methods: {
    setDialog(v, addOrgForm) {
      console.log(addOrgForm);
      if (v) {
        //是编辑保存
        if (this.dialogType == "normalType") {
          updateResource(this.currentForm).then((res) => {
            if(res.code=='AUTH_000000'){
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.showDrawer = false;
              //更新查询
              this.query();
            }else{
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          //是确认删除
          this.confirmDelete();
        }
      }
      this.dialogFormVisible = false;
    },
    confirmDelete() {
      let ids = [];
      this.selectedItems.forEach((item) => {
        ids.push(item.id);
      });
      deleteResource({ ids: ids }).then((res) => {
        if(res.code=='AUTH_000000'){
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.query();
          }else{
             this.$message({
              type: "error",
              message: res.msg,
            });
          }
      });
    },
    deleteItem() {
      //需要弹框二次确认
      this.dialogFormVisible = true;
      this.dialogType = "yellowType";
    },
    addoredit(obj) {
      let data = obj.form;
      if (this.drawerMode == "add") {
        this.showDrawer = false;
        data.resParent = this.selectedItems[0]
        ? this.selectedItems[0].details.resCode
        : "";
        addResource(data).then((res) => {
          if(res.code=='AUTH_000000'){
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.changeDrawer(false);
            //更新查询
            this.query();
          }else{
             this.$message({
              type: "error",
              message: res.msg,
            });
          }
        });
      } else {
        //如果选择的是第一级，resParent是自己的code。否则是父级的code
        let resParent=''
        this.tableData.list.forEach(item=>{
          if(this.selectedItems[0].details.resCode==item.details.resCode){
            resParent=this.selectedItems[0].details.resCode
          }else{
            this.findFather(item)
          }
        })
        //编辑需要二次弹框
        data.resParent=resParent||this.father.details.resCode
        this.currentForm = data;
        this.dialogFormVisible = true;
        this.eventType = "confirmEdit";
        this.dialogType = "normalType";
      }
    },
    findFather(item){
      item.childNode.forEach(item2=>{
        if(this.selectedItems[0].details.resCode==item2.details.resCode){
                this.father=item
              }else{
                this.findFather(item2)
              }
            })          
    },
    changeDrawer(v) {
      this.showDrawer = v;
    },
    callBackAction(param) {
      this.selectedItems = param.selectedItems;
      this.formInline = param.formInline;
      if (param.event !== "handleSelectionChange") {
        this[param.event](param);
      }
    },
    query() {
      let data = {
        currentPage: this.formInline.currentPage || 1,
        pageSize: this.formInline.pageSize || 10,
        condition: {
          vagueParam: this.formInline.inputKey || "",
        },
      };
      //查询资源
      getResourceTree(data).then((res) => {
        this.tableData = res.data;
        this.$nextTick(()=>{
          this.$refs.child.$refs.multipleTable.clearSelection();
        })
      });
    },
    add() {
      //不选择就是新增根级
      // if (this.selectedItems.length > 1) {
      //   this.$message({
      //     type: "info",
      //     message: this.$t(`authorization.member.onlyChooseOne`),
      //   });
      //   return;
      // }
      // else if(this.selectedItems.length==0){//必须选择父级才能新增
        // this.$message({
        //   type: "info",
        //   message: this.$t(`authorization.member.mustChooseOne`),
        // });
        // return;
      // }
      this.changeDrawer(true);
      this.drawerMode = "add";
      this.drawerTitle = this.$t(`authorization.resource.addResTitle`);
      this.formData = this.tableConfig.table.columns;
      this.$set(this, "addoreditForm", {});
    },
    edit() {
      if (this.selectedItems.length > 1) {
        this.$message({
          type: "info",
          message: this.$t(`authorization.member.onlyChooseOne`),
        });
        return;
      }
      this.changeDrawer(true);
      this.drawerMode = "edit";
      this.drawerTitle = this.$t(`authorization.resource.editResTitle`);
      this.formData = this.tableConfig.table.columns;
      this.$set(
        this,
        "addoreditForm",
        Object.assign(
          {
            label: this.selectedItems[0].label,
            type: this.selectedItems[0].type,
          },
          this.selectedItems[0].details
        )
      );
    },
    remove() {
      this.deleteItem();
    },
    connect() {},
    export() {},
  },
};
</script>
<style lang="less" scoped></style>
